import { S3_PATH } from "@bridgesplit/ui";
import { RouteStepType } from "@loopscale/pandora-types";

type ExchangeMeta = {
    image: string;
    name: string;
    url: string;
};

const EXCHANGE_META: Record<RouteStepType, (isDarkMode?: boolean) => ExchangeMeta | undefined> = {
    [RouteStepType.JUPITER]: () => ({
        image: `${S3_PATH}/logo/jupiter.png`,
        name: "Jupiter",
        url: "https://jup.ag"
    }),

    [RouteStepType.TITAN]: (isDarkMode) => ({
        image: isDarkMode ? `${S3_PATH}/logo/titan-light.png` : `${S3_PATH}/logo/titan-dark.ico`,
        name: "Titan",
        url: "https://titan.exchange"
    }),

    [RouteStepType.HYLO]: () => ({
        image: `${S3_PATH}/logo/hylo.png`,
        name: "Hylo",
        url: "https://hylo.so/leverage"
    }),

    [RouteStepType.ONRE]: () => ({
        image: `${S3_PATH}/logo/onre_general.jpeg`,
        name: "OnRe",
        url: "https://app.onre.finance/earn"
    }),

    [RouteStepType.DFLOW]: () => undefined,
    [RouteStepType.MARKET_AGGREGATOR]: () => undefined,
    [RouteStepType.FLASH]: () => undefined,

    [RouteStepType.STAKE_POOL]: () => ({
        image: `${S3_PATH}/logo/stkesol.png`,
        name: "Stake Pool",
        url: "https://solscan.io/account/StKeDUdSu7jMSnPJ1MPqDnk3RdEwD2QbJaisHMebGhw"
    }),

    [RouteStepType.EXPONENT]: () => ({
        image: `${S3_PATH}/logo/exponent.png`,
        name: "Exponent",
        url: "https://app.exponent.finance/income"
    }),

    [RouteStepType.RATEX]: () => ({
        image: `${S3_PATH}/logo/ratex.png`,
        name: "RateX",
        url: "https://app.rate-x.io/leverage"
    }),

    [RouteStepType.PLUME]: () => undefined,
    [RouteStepType.FISSION]: () => ({
        image: `${S3_PATH}/logo/fission.png`,
        name: "Fission",
        url: "https://fission.xyz/"
    }),

    [RouteStepType.EXPONENT_ORDERBOOK]: () => undefined,
    [RouteStepType.EXPONENT_CLMM]: () => undefined,
    [RouteStepType.RWA_AGGREGATOR]: () => undefined,
    [RouteStepType.GLOW]: () => undefined,
    [RouteStepType.GLAM]: () => undefined
};

export function getExchangeMeta(exchangeName: RouteStepType, isDarkMode?: boolean): ExchangeMeta | undefined {
    return EXCHANGE_META[exchangeName]?.(isDarkMode);
}
